import(/* webpackMode: "eager", webpackExports: ["PublicBookingExperience"] */ "/codebuild/output/src3559949965/src/agendamento-front/app/[slug]/PublicBookingExperience.tsx");
